import { MARGIN_MODAL_WIDGET_TYPES } from './enums'

export const modalWidgetMenuItems = [
  {
    id: MARGIN_MODAL_WIDGET_TYPES.BORROW,
    title: 'Borrow',
  },
  {
    id: MARGIN_MODAL_WIDGET_TYPES.REPAY,
    title: 'Repay',
  },
]
